import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import DropdownSelect from '../DropdownSelect'
import Input from '#components/a/form/Input'
import Text from '#components/a/Text'

const CUSTOM_TERMIN = 'custom'
const CUSTOM_TERMIN_MAX_LENGTH = 60

export default class TerminTypeInput extends React.Component {
  constructor(props) {
    super(props)

    this.TERMIN_TYPES = [
      {value: `${i18n.t('termin_berufsschule')}`, label: `${i18n.t('termin_berufsschule')}`},
      {value: `${i18n.t('termin_seminar')}`, label: `${i18n.t('termin_seminar')}`},
      {value: `${i18n.t('termin_urlaub')}`, label: `${i18n.t('termin_urlaub')}`},
      {value: CUSTOM_TERMIN, label: `${i18n.t('termin_eigener_termin')}`},
    ]

    const isCustomType = subject => this.TERMIN_TYPES.find(t => t.value === subject) === undefined
    const parseSubject = subject => this.TERMIN_TYPES.find(t => t.value === subject)
    if (!props.initialSubject) {
      this.state = {
        selectedTerminType: this.TERMIN_TYPES[0],
        customTerminTitle: '',
      }
      props.onTerminTypeChanged(this.state.selectedTerminType.value)
    } else {
      const isCustom = isCustomType(props.initialSubject)
      this.state = {
        selectedTerminType: isCustom
          ? this.TERMIN_TYPES[this.TERMIN_TYPES.length - 1]
          : parseSubject(props.initialSubject),
        customTerminTitle: isCustom ? props.initialSubject : '',
      }
    }
  }

  onSelectTerminType = evt => {
    const {onTerminTypeChanged} = this.props
    const {customTerminTitle} = this.state

    const subject = evt === this.TERMIN_TYPES[3] ? customTerminTitle : evt.value

    this.setState({selectedTerminType: evt})
    onTerminTypeChanged(subject)
  }

  onCustomTitleChanged = text => {
    const {onTerminTypeChanged} = this.props
    const {selectedTerminType} = this.state

    const subject = selectedTerminType === this.TERMIN_TYPES[3] ? text : selectedTerminType

    this.setState({customTerminTitle: text})
    onTerminTypeChanged(subject)
  }

  render() {
    const {selectedTerminType, customTerminTitle} = this.state
    const remainingLetters = CUSTOM_TERMIN_MAX_LENGTH - customTerminTitle.length
    return (
      <div className="terminType">
        <Text text={i18n.t('termin_types')} />
        <DropdownSelect
          options={this.TERMIN_TYPES}
          selectedOption={selectedTerminType}
          handleSelect={evt => this.onSelectTerminType(evt)}
        />
        {selectedTerminType.value === CUSTOM_TERMIN && (
          <div>
            <div className="textWrapper">
              <Text text={i18n.t('termin_titel')} />
              <Text text={i18n.t('remaining_letters_hint', [remainingLetters])} modifier="hint" />
            </div>
            <Input
              type="text"
              required
              value={customTerminTitle}
              maxLength={CUSTOM_TERMIN_MAX_LENGTH}
              onChangeHandle={evt => this.onCustomTitleChanged(evt.target.value)}
            />
          </div>
        )}
      </div>
    )
  }
}

TerminTypeInput.propTypes = {
  onTerminTypeChanged: PropTypes.func,
}
